module.exports = __webpack_public_path__ + "img/curated-images.e5677e7b.jpg";